/**
 * CustomFields module.
 * @module CustomFields
 */

export { CustomFieldsClient } from './CustomFieldsClient';


// WEBPACK FOOTER //
// ./src/main/javascript/CustomFields/index.js